import React, { useState } from 'react';
import { X } from 'lucide-react';
import { equipmentAPI } from '../../services/api';

export default function AddService({ equipmentId, existingService, onClose, onSaved }) {
  const isEdit = !!existingService;
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    service_date: existingService?.service_date
      ? new Date(existingService.service_date).toISOString().slice(0, 10)
      : new Date().toISOString().slice(0, 10),
    service_type: existingService?.service_type || 'ROUTINE',
    running_hours: existingService?.running_hours ?? '',
    description: existingService?.description || '',
    parts_replaced: existingService?.parts_replaced || '',
    service_cost: existingService?.service_cost ?? '',
    vendor_name: existingService?.vendor_name || '',
    next_service_due: existingService?.next_service_due
      ? new Date(existingService.next_service_due).toISOString().slice(0, 10)
      : '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form };
      if (payload.service_cost) payload.service_cost = parseFloat(payload.service_cost);
      if (payload.running_hours) payload.running_hours = parseFloat(payload.running_hours);

      if (isEdit) {
        await equipmentAPI.updateService(equipmentId, existingService.id, payload);
      } else {
        await equipmentAPI.addService(equipmentId, payload);
      }
      onSaved();
    } catch (err) {
      alert(err.message || `Failed to ${isEdit ? 'update' : 'add'} service`);
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">{isEdit ? 'Edit Service' : 'Add Service'}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Service Date *</label>
            <input type="date" name="service_date" value={form.service_date} onChange={handleChange} required className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Service Type</label>
            <select name="service_type" value={form.service_type} onChange={handleChange} className={inputCls}>
              <option value="ROUTINE">Routine</option>
              <option value="REPAIR">Repair</option>
              <option value="EMERGENCY">Emergency</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Running Hours</label>
            <input type="number" step="0.1" name="running_hours" value={form.running_hours} onChange={handleChange} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} rows={2} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Parts Replaced</label>
            <input name="parts_replaced" value={form.parts_replaced} onChange={handleChange} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Service Cost (₹)</label>
            <input type="number" step="0.01" name="service_cost" value={form.service_cost} onChange={handleChange} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Vendor</label>
            <input name="vendor_name" value={form.vendor_name} onChange={handleChange} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Next Service Due</label>
            <input type="date" name="next_service_due" value={form.next_service_due} onChange={handleChange} className={inputCls} />
          </div>
          <div className="flex gap-3 pt-4">
            <button type="submit" disabled={loading} className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50">
              {loading ? 'Saving...' : isEdit ? 'Update' : 'Save'}
            </button>
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
